<template>
<div class="page-goods-order-sub container">
    <div class="container-flex bg">
        <div class="green-bg"></div>
        <div class="container-flex-center">
            <div class="goods-info-box goods-info-box-frist">
                <div class="goods-info-title">配送方式</div>
                <div class="type-radio-box">
                    <div class="type-radio" @click="typcClick(1)">
                        <img class="type-radio-img" v-if="type == 1" src="../../assets/image/radio-yes.png" />
                        <img class="type-radio-img" v-else src="../../assets/image/radio.png" />
                        快递
                    </div>
                    <div class="type-radio tow" @click="typcClick(2)">
                        <img class="type-radio-img"  v-if="type == 2" src="../../assets/image/radio-yes.png" />
                        <img class="type-radio-img" v-else src="../../assets/image/radio.png" />
                        自提
                    </div>
                </div>
                <template v-if="type == 1">
                    <div class="address-box" v-if="addressList.length > 0">
                        <pi-order-address @change="selectAddress" :address="addressData"></pi-order-address>
                    </div>
                    <div class="address-content address-no-box" v-else @click="addAddress">
                        <div class="add-address">
                            <img class="address-no-icon" src="../../assets/image/mall-no-adderss.png" />
                            <div class="add-address-btn">添加收货地址</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="address-box" v-if="oprAddressList.length > 0">
                        <pi-order-address @change="selectAddressOper" :type="2" :address="oprAddressData"></pi-order-address>
                    </div>
                    <div class="address-content address-no-box" v-else>
                        <div class="add-address">
                            <img class="address-no-icon" src="../../assets/image/mall-no-adderss.png" />
                            <div class="add-address-btn">暂无自提地址</div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="goods-details-box goods-info-box">
                <pi-order-item-data :goodsData="pointsGoodsOrderData" :isTotal="false"></pi-order-item-data>
            </div>
        </div>
    </div>
    <div class="exchange-info">
        <div class="exchange-flex v-center-sx">
            <div class="exchange-total">合计：<span class="money">{{pointsGoodsOrderData.totalPrice}}积分</span> </div>
            <!-- <div class="my-total">剩余：{{pointsGoodsOrderData.surplusMoney}}积分</div> -->
        </div>
        <div class="exchange-btn-box">
            <div class="exchange-btn" :class="!addressData.pkid && type == '1' ? 'disabled' : ''" @click="submitMallorder">立即兑换</div>
        </div>
    </div>
</div>
</template>

<script>
import { getMyMallAddress,getPprMallAddress,submitMallorder } from "../../common/api/index";
import piOrderItemData from "@/components/pi-order-item-data/pi-order-item-data";
import piOrderAddress from "@/components/pi-order-address/pi-order-address";
export default {
  name: "points-goods-order-sub",
  components: {
    [piOrderItemData.name]: piOrderItemData,
    [piOrderAddress.name]: piOrderAddress,
  },
  data() {
    return {
      num: 1,
      type:1,
      addressList: [],
      oprAddressList: [],
      addressData: {},
      oprAddressData: {},
      pointsGoodsOrderData: {},
      loading : false
    };
  },
  methods: {
    async getSelectAddress(){
      let addressData = this.$common.get('selectAddress');
      let oprAddressData = this.$common.get('selectOprAddress');
      
      if(addressData){
        this.addressData = addressData;
        this.$common.remove('selectAddress');
        this.typcClick(1)
      }
      if(oprAddressData){
        this.oprAddressData = oprAddressData;
        this.$common.remove('selectOprAddress');
        this.typcClick(2)
      }
    },
    async getOrderData(){
      let pointsGoodsOrderData = this.$common.get('pointsGoodsOrderData');
      if(pointsGoodsOrderData){
        this.pointsGoodsOrderData = pointsGoodsOrderData;
      }
    },
    async getMyMallAddress(){
      let ret = await getMyMallAddress({});
      if (ret.status === 0) {
        let data = ret.data || [];
        this.addressList = data;
        if(!this.addressData.pkid){
          this.addressData = data[0] || {};
        }
      }
    },
    async getPprMallAddress(){
      let ret = await getPprMallAddress({});
      if (ret.status === 0) {
        let data = ret.data || [];
        let oprAddressList = [];
        data.map(item=>{
          if(item.status == 1){
            item = this.getAddressData(item);
            oprAddressList.push(item);
          }
        })
        this.oprAddressList= oprAddressList;
        if(!this.oprAddressData.mallAddressPkId){
          this.oprAddressData= oprAddressList[0] || {};
        }
        
      }
    },
    getAddressData(item){
      item.receiver = item.regionName;
      item.receiver = item.contacts;
      item.phone = item.contactsPhone;
      return item;
    },
    
    selectAddress(){
      this.$router.push("/points-address?type=select");
    },
    selectAddressOper(){
      this.$router.push("/points-address-oper?type=select");
    },
    addAddress(){
      this.$router.push("/points-address-add");
    },
    typcClick(type){
      this.type = type;
      if(type == '2' && this.oprAddressList.length == 0){
        this.getPprMallAddress();
      }else if(type == '1' && this.addressData.length == 0){
        this.getMyMallAddress();
      }
    },
    async submitMallorder(){
      if(this.loading){
        return
      }
      if(this.type =='1' && this.addressData.pkid || this.type =='2' && this.oprAddressData.mallAddressPkId){
        let pointsGoodsOrderData = this.pointsGoodsOrderData;
        let pointPrice = pointsGoodsOrderData.discountRatio != 100 ? pointsGoodsOrderData.discountPrice : pointsGoodsOrderData.price;
        this.loading = true;
        let ret = await submitMallorder({
          deliveryMethod: this.type,
          goodsList: [
            {
              goodsPkId: pointsGoodsOrderData.mallProductPkId,
              pointPrice:pointPrice,
              quantity: pointsGoodsOrderData.num
            }
          ],
          mallPkId: pointsGoodsOrderData.mallPkId, // 
          paymentMethod: 1,
          expressAddPkId: this.type == 1? this.addressData.pkid : '',
          mallAddPkId: this.type == 2? this.oprAddressData.mallAddressPkId : '',
        })
        if (ret.status === 0) {
          this.$toast('下单成功','success');
          setTimeout(()=>{
            this.$router.push("/points-order");
          },1000)
          
        }else{
          this.$toast(ret.msg,'none');
        }
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getOrderData();
    this.getMyMallAddress();
    this.getSelectAddress();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-goods-order-sub{
    
  .goods-info-box{
      background-color: #fff;
      margin-top: 0.10rem;
      padding: 0.20rem;
      position: relative;
  }
  .goods-info-title{
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #000;
  }
  .goods-info-text{
      line-height: 0.33rem;
      font-size: 0.24rem;
      color: #666;
      margin-top: 0.10rem;
  }   

  .type-radio-box{
      position:absolute;
      right: 0.20rem;
      top: 0.20rem;
      font-size: 0.28rem;
      line-height: 0.40rem;
      color: #666;
  }
  .type-radio-box .type-radio-img{
      width: 0.30rem;
      height: 0.30rem;
      display: inline-block;
  }
  .type-radio-box  .tow{
      margin-left: 0.80rem;
  }
  .type-radio{
      display: inline-block;
      vertical-align: top;
  }

  .exchange-info{
      background: #FFFFFF;
      box-shadow: 0px 0px 2px 3px rgba(102, 102, 102, 0.2);
      display: flex;
      padding: 0.18rem 0.30rem;
  }
  .exchange-flex{
      flex: 1;
      // text-align: right;
  }
  .exchange-total{
      font-size: 0.32rem;
      line-height: 0.40rem;
      color: #666;
  }
  .exchange-total .money{
      color: #000;
  }
  .my-total{
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #999;
  }
  .green-bg{
      background-color: #14CC80;
      height: 0.94rem;
  }
  .goods-info-box-frist{
      margin-top: -0.74rem;
      border-radius: 0.12rem 0.12rem 0 0;
  }
  .container-flex-center{
      padding: 0 0.20rem;
  }
  .exchange-btn{
      padding: 0.17rem 0.48rem;
      display: inline-block;
      background-color: #14CC80;
      color: #fff;
      font-size: 0.36rem;
      line-height: 0.50rem;
      border-radius: 0.50rem;
      margin-left: 0.20rem;
  }
  .exchange-btn.disabled{
      opacity: 0.3;
      border: none;
  }
  .address-box{
      margin-top: 0.35rem;
  }
  .address-content.address-no-box{
      justify-content: center;
      align-items: center;
      margin-top: 0.36rem;
  }
  .address-no-box .address-no-icon{
      width: 1.50rem;
      height: 0.97rem;
      display: block;
      margin: auto;
  }
  .address-no-box  .add-address{
      text-align: center;
  }
  .address-no-box .add-address-btn{
      padding: 0.03rem 0.10rem;
      font-size: 0.18rem;
      line-height: 0.25rem; 
      background: linear-gradient(180deg, #2DE8B7 0%, #14CC80 100%);
      border-radius: 0.30rem;
      color: #fff;
      display: inline-block;
      margin-top: 0.30rem;
  } 
}
</style>
